import { ComparableListRemote } from "src/app/core/valuation-process/_services/valuation-comparable.service"

export interface ComparableListItem {
  refNum: string,
  propertySubTypeId: number,
  propertySubTypeName: string,
  buildingName: string,
  street: string,
  communityName: string,
  bedrooms: number,
  size: number,
  sizeAcronym: string,
  price: number,
  pricePerSize: number,
  currency: string,
  transactionType: string,
  sourceDate: Date,
  offerType: string,
}

/**
 * A server list row as the table renders it. Every displayed value is already resolved
 * server-side — this only renames fields and turns the date into a Date, so that the
 * column the table sorts by is the same value the database sorted by.
 */
export function mapRemoteToListItem(remote: ComparableListRemote): ComparableListItem {
  return {
    refNum: remote.refNum,
    propertySubTypeId: remote.propertySubTypeId,
    propertySubTypeName: remote.propertySubTypeName,
    buildingName: remote.buildingName,
    street: remote.street,
    communityName: remote.communityName,
    bedrooms: remote.bedrooms,
    size: remote.size,
    sizeAcronym: remote.sizeAcronym,
    price: remote.price,
    pricePerSize: remote.pricePerSize,
    currency: remote.currency,
    transactionType: remote.evidenceType,
    sourceDate: remote.date ? new Date(remote.date) : null,
    offerType: remote.offerType
  }
}
